import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["caption", "children", "disabled", "id", "imageAlt", "imageSrc", "info", "labelProps", "name", "title", "type", "value", "onFocus", "onBlur"];
import React, { forwardRef } from 'react';
import cx from 'classnames';
import { Checkmark } from '@mediahuis/chameleon-theme-wl/icons';
import Icon from '../Icon';
import system from '../../system';
import styles from './index.module.scss';
import ChoiceInfo from './ChoiceInfo';
import ChoiceTitle from './ChoiceTitle';
import ChoiceBody from './ChoiceBody';
import ChoiceCaption from './ChoiceCaption';
import ChoiceImage from './ChoiceImage';
var SYSTEM_PROPS = ['marginProps', 'floatProps'];
var Choice = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _cx;

  var caption = _ref.caption,
      children = _ref.children,
      disabled = _ref.disabled,
      id = _ref.id,
      imageAlt = _ref.imageAlt,
      imageSrc = _ref.imageSrc,
      info = _ref.info,
      labelProps = _ref.labelProps,
      name = _ref.name,
      title = _ref.title,
      type = _ref.type,
      value = _ref.value,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _system = system(props, SYSTEM_PROPS),
      className = _system[0],
      style = _system[1],
      rest = _system[2];

  return /*#__PURE__*/React.createElement("label", _extends({
    className: cx(className, styles.root),
    style: style,
    htmlFor: id
  }, labelProps), /*#__PURE__*/React.createElement("input", _extends({}, rest, {
    className: styles.input,
    disabled: disabled,
    id: id,
    name: name,
    type: type,
    value: value,
    ref: ref,
    onFocus: onFocus,
    onBlur: onBlur
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("div", {
    className: cx((_cx = {}, _cx[styles.iconContainer] = true, _cx[styles.checkboxContainer] = type === 'checkbox', _cx[styles.radioContainer] = type === 'radio', _cx))
  }, /*#__PURE__*/React.createElement(Icon, {
    className: styles.icon,
    as: Checkmark,
    size: "small"
  })), /*#__PURE__*/React.createElement("header", {
    className: styles.header
  }, !!imageSrc && /*#__PURE__*/React.createElement(ChoiceImage, {
    src: imageSrc,
    alt: imageAlt
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.center
  }, info && /*#__PURE__*/React.createElement(ChoiceInfo, null, info), /*#__PURE__*/React.createElement(ChoiceTitle, null, title), caption && /*#__PURE__*/React.createElement(ChoiceCaption, null, caption))), children && /*#__PURE__*/React.createElement(ChoiceBody, null, children)));
});
Choice.displayName = 'Choice';
Choice.identifier = Choice.displayName;
Choice.clonableProps = SYSTEM_PROPS;
Choice.defaultProps = {
  type: 'radio'
};
export default Choice;